var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 9C8.03486 9 8.33333 8.70152 8.33333 8.33333C8.33333 7.96514 8.03486 7.66667 7.66667 7.66667C7.29848 7.66667 7 7.96514 7 8.33333C7 8.70152 7.29848 9 7.66667 9Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 4.33333C8.03486 4.33333 8.33333 4.03486 8.33333 3.66667C8.33333 3.29848 8.03486 3 7.66667 3C7.29848 3 7 3.29848 7 3.66667C7 4.03486 7.29848 4.33333 7.66667 4.33333Z",
    fill: "#5C5C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 13.6667C8.03486 13.6667 8.33333 13.3682 8.33333 13C8.33333 12.6318 8.03486 12.3333 7.66667 12.3333C7.29848 12.3333 7 12.6318 7 13C7 13.3682 7.29848 13.6667 7.66667 13.6667Z",
    fill: "#5C5C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 9C8.03486 9 8.33333 8.70152 8.33333 8.33333C8.33333 7.96514 8.03486 7.66667 7.66667 7.66667C7.29848 7.66667 7 7.96514 7 8.33333C7 8.70152 7.29848 9 7.66667 9Z",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 4.33333C8.03486 4.33333 8.33333 4.03486 8.33333 3.66667C8.33333 3.29848 8.03486 3 7.66667 3C7.29848 3 7 3.29848 7 3.66667C7 4.03486 7.29848 4.33333 7.66667 4.33333Z",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 13.6667C8.03486 13.6667 8.33333 13.3682 8.33333 13C8.33333 12.6318 8.03486 12.3333 7.66667 12.3333C7.29848 12.3333 7 12.6318 7 13C7 13.3682 7.29848 13.6667 7.66667 13.6667Z",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenu);
export default __webpack_public_path__ + "static/media/more_menu.729198f52d4c6ef8235de0ddcccd4234.svg";
export { ForwardRef as ReactComponent };